import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            cursor: initial;\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            ", "\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        cursor: pointer;\n        transition: all ", "s ease;\n        ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { CancelIcon } from '@deliveryhero/armor-icons';
import { transitionDurationInSec } from '../../../constants';
import { getPropsBlocker, makePropList } from '../../../utils';
import { getComponentOverride } from '../../../system/mixins/getComponentOverride';
var propertyList = makePropList(['searchQuery']);

var clearIconContainerStyle = function clearIconContainerStyle(_ref) {
  var SearchClearAction = _ref.theme.componentOverrides.SearchClearAction;
  return SearchClearAction.ClearIconContainer.base;
};

var searchInputClearIconStyle = function searchInputClearIconStyle(_ref2) {
  var disabled = _ref2.disabled,
      searchQuery = _ref2.searchQuery,
      SearchClearAction = _ref2.theme.componentOverrides.SearchClearAction;
  var result = css(_templateObject(), transitionDurationInSec, SearchClearAction.ClearIcon.base);

  if (disabled) {
    result = css(_templateObject2(), result, SearchClearAction.ClearIcon.disabled);
  } else if (!searchQuery) {
    result = css(_templateObject3(), result, SearchClearAction.ClearIcon.transparent);
  }

  return result;
};

export var ClearIconContainer = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4(), clearIconContainerStyle);
export var SearchInputClearIcon = styled(CancelIcon).withConfig(getPropsBlocker(propertyList, false))(_templateObject5(), searchInputClearIconStyle, getComponentOverride('SearchClearAction'));